import React from 'react';
import './styles/App.css';
import Hero from './components/Hero';
import Profile from './components/Profile'; // 引入Profile组件
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {
  return (
    <div className="App">
      <Hero />
      <Profile /> {/* 添加Profile组件 */}
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
